import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { AccountSelectContainer } from './containers/AccountSelectContainer';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { HelpContainer } from '../HelpContainer';
import { trackAccountSelectOpen } from './tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AccountSelectView = function AccountSelectView(_ref) {
  var source = _ref.source;
  React.useEffect(function () {
    trackAccountSelectOpen(source);
  }, []);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(SubtitleLayout, {
      children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
    }), /*#__PURE__*/_jsx(AccountSelectContainer, {}), /*#__PURE__*/_jsx(HelpContainer, {})]
  });
};